import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';
import { VariablesProvider } from '../../providers/variables/variables';

interface Turno {
  id: number;
  nombre: string;
  horaInicio: string;
  horaFin: string;
  color: string;
}

@Component({
  selector: 'mod-turno-simple',
  templateUrl: 'mod-turno-simple.html'
})
export class TurnoSimpleModal {
  turnos: Turno[] = [];

  // Usamos un "sentinela" para la opción "por defecto"
  // y evitamos el id DOM tipo "rb-19-0".
  turnoId: 'DEFAULT' | number = 'DEFAULT';

  defaultLabel: string = 'Por defecto (según trabajador)';

  constructor(
    private viewCtrl: ViewController,
    private variables: VariablesProvider,
    private params: NavParams
  ) {
    // Asegura fallback a [] si no viene nada
    const t = (this.params.get('turnos') as Turno[]) || [];
    // Clona y ordena por nombre sin mutar el array original
    this.turnos = t.slice().sort((a, b) => (a.nombre || '').localeCompare(b.nombre || ''));

    const lbl = this.params.get('defaultLabel');
    if (lbl) this.defaultLabel = lbl;
  }

  aplicar() {
    // Convertimos el sentinela a null antes de devolverlo
    const elegido = this.turnoId === 'DEFAULT' ? "-1" : Number(this.turnoId);
    this.viewCtrl.dismiss({ ok: true, turnoId: elegido });
  }

  cancelar() {
    this.viewCtrl.dismiss({ ok: false });
  }

  borrar() {
    // Fuerza uso de "por defecto" (null) explícitamente
    this.viewCtrl.dismiss({ ok: true, turnoId: "-1" });
  }
}



// WEBPACK FOOTER //
// ./src/pages/asignar/mod-turno-simple.ts